(function ($) {

    $.fn.tabsSlider = function () {
        const $main = $(this);
        const openTabsClass = "tabs-slider__tab--open";
        const openSlidesClass = "tabs-slider__slide-group--visible";
        let animating = false;

        $(this).on("click", ".tabs-slider__tab-title", function () {
            const $tab = $(this).parent(".tabs-slider__tab");
            const forGroup = $tab.data("tabfor");
            
            if (!$tab.hasClass(openTabsClass) && !animating) {
                animating = true;
                const $openTab = $main.find("." + openTabsClass);
                const $openSlide = $main.find("." + openSlidesClass);

                $openSlide.removeClass(openSlidesClass);
                $(".tabs-slider__slide-group[data-slidesfor='" + forGroup + "']").addClass(openSlidesClass);
                $openTab.find(".tabs-slider__tab-content").slideUp(400, function () {
                    $openTab.removeClass(openTabsClass);
                });
                $tab.find(".tabs-slider__tab-content").slideDown(400, function () {
                    $tab.addClass(openTabsClass);
                    animating = false;
                });
            }
        });
        
        $(this).find(".tabs-slider__slide-wrapper").slick({
            arrows: false,
            dots: true,
            fade: true,
            autoplay: true,
        });

        // Updates "Bekijk alle spirits" link per slide
        $('.tabs-slider__slider .slick-slider').on('beforeChange', function (e, slick, currentSlide, nextSlide) {
            var $slide = $(this).find('.slick-slide').eq(nextSlide),
                $link = $(this).siblings().filter('a'),
                href = $slide.data('href'),
                caption = $slide.data('caption');
            $link.text(caption).attr('href', href);
        });
    };

    $(document).ready(function () {
        if ($(".tabs-slider").length) {
            if ($(window).width() <= 767) {
                $(".tabs-slider__tab--open").removeClass("tabs-slider__tab--open");
            }
            
            $(".tabs-slider").each(function () {
                $(this).tabsSlider();
            });
        }
    });

})(jQuery);